import classNames from 'classnames';
import styles from './index.module.scss';

type ProgressBarProps = {
  progress: number;
};

export const ProgressBar: React.FC<ProgressBarProps> = ({ progress }) => {
  const isCompleted = progress === 100;

  return (
    <div className={styles.progressBarContainer}>
      <div
        className={classNames(styles.progressBar, {
          [styles.completed]: isCompleted,
        })}
        style={{
          width: `${progress}%`,
        }}
      >
        {/* TODO: 100%に近くなった時の吹き出しアイコン調整 */}
        <span
          className={classNames(styles.progressText, {
            [styles.completed]: isCompleted,
          })}
        >
          {progress}%
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
